<script lang="ts">
    import '../css/app.pcss';
    import { t, locale } from 'svelte-i18n';
    import { page } from '$app/stores';
    import { type SupportedLocale, supportedLocales } from '$lib/i18n/initI18n.js';
    import VVMWindrose from '$lib/assets/vectors/VVMWindrose.svelte';
    import Button from '$lib/daisyUiComponents/ButtonVV.svelte';
    import ReducedMainNavbar from '$lib/components/navigation/ReducedMainNavbar.svelte';
    import Footer from '$lib/components/navigation/Footer.svelte';

    const translations = {
        de: ['Fehlerursache', 'Hier sollten Sie nicht sein.', 'Zurück zur Startseite'],
        en: ['Error cause', "You shouldn't be here.", 'Back to the homepage']
    };

    const languageParamRegex = new RegExp('^/(' + supportedLocales.join('|') + ')');
    const languageParam = languageParamRegex.exec($page.url.pathname)?.[1] as SupportedLocale | undefined;

    locale.set(languageParam ?? 'en');

    const translation = translations[languageParam!] ? translations[languageParam!] : translations.en;
</script>

<svelte:head>
    <title>{$t('shop.meta.title')} | {$page.error?.message}</title>
    <meta name="description" content={$t('shop.meta.description')} />
</svelte:head>

<ReducedMainNavbar />

<section class="font-jost w-full h-full min-h-screen bg-neutral flex justify-center items-center px-5">
    <div
        class="absolute top-[calc(-50%+120px)] md:top-8 2xl:top-0 left-0 w-full h-full flex justify-center items-center overflow-hidden z-0"
    >
        <VVMWindrose />
    </div>
    <div class="flex items-center flex-col mb-4 text-center z-10">
        <p class="text-grey text-base md:text-17px font-medium mb-3 tracking-[0.02em]">
            {translation[0]}: {$page.error?.message}
        </p>
        <h1
            class="text-[2.56rem] sm:text-[2.62rem] md:text-[2.68rem] lg:text-[2.74rem] xl:text-[2.8rem] 2xl:text-[2.875rem] font-cinzel uppercase text-chamois leading-[1.15em] tracking-[0.03em]"
        >
            {translation[1]}
        </h1>
        <Button color="primary" href="/" style class="mt-10 !text-neutral">{translation[2]}</Button>
    </div>
</section>

<Footer />
